<template>
  <v-dialog
    ref="dialog"
    v-model="modal"
    :return-value.sync="value"
    persistent
    width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="value"
        style="background-color: white"
        :class="className"
        :disabled="disabled"
        hide-details
        outlined
        dense
        clearable
        @click:clear="$emit('input', null)"
        readonly
        v-bind="attrs"
        v-on="on"
        :rules="rules"
      ></v-text-field>
    </template>
    <v-time-picker
      v-if="modal"
      :value="value"
      @input="onInput"
      full-width
      format="24hr"
    >
      <v-spacer></v-spacer>
      <v-btn text color="primary" @click="$refs.dialog.save(value)"> OK </v-btn>
    </v-time-picker>
  </v-dialog>
</template>

<script>
export default {
  name: 'TimePicker',
  props: ['value', 'className', 'disabled', 'rules'],
  data() {
    return {
      modal: false,
    }
  },
  methods: {
    onInput(value) {
      this.$emit('input', value)
    },
  },
}
</script>

<style scoped>
.centered-input >>> input {
  text-align: center;
}

.red-text-input >>> input {
  color: red;
}
</style>
